import { render, staticRenderFns } from "./GroupsPage.vue?vue&type=template&id=719915e1&scoped=true&"
import script from "./GroupsPage.vue?vue&type=script&lang=ts&"
export * from "./GroupsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719915e1",
  null
  
)

export default component.exports